import type { TienDoLichSu } from '@qlk/shared';

/**
 * Nhãn "Đang lấy lịch sử · x/120 ngày" và chú thích "chưa đủ dữ liệu".
 *
 * Kênh mới kết nối mất vài phút mới có đủ 120 ngày. Trong lúc đó mọi con số 28
 * ngày, 90 ngày đều nhỏ hơn thực tế — không nói ra thì người xem tưởng kênh tụt
 * traffic.
 */
export function NhanDangLayLichSu({ lichSu }: { lichSu: TienDoLichSu | null | undefined }) {
  if (!lichSu?.dangChay) return null;

  return (
    <span
      className="inline-flex items-center gap-1 rounded-chip bg-info-nen px-2 py-0.5 text-phu font-medium text-info-chu"
      title="App đang lấy số liệu lịch sử của kênh này. Các chỉ số sẽ đủ sau khi xong."
    >
      Đang lấy lịch sử · {lichSu.soNgayDaCo}/{lichSu.soNgayCan} ngày
    </span>
  );
}

/**
 * Chú thích khi kỳ đang xem **thiếu ngày**: hiện số ngày thật sự có.
 *
 * Dùng chung cho thẻ chỉ số của một kênh và dòng tổng.
 */
export function ChuThichChuaDuDuLieu({
  soNgayDaCo,
  soNgayCuaKy,
}: {
  soNgayDaCo: number | null | undefined;
  soNgayCuaKy: number;
}) {
  if (soNgayDaCo === null || soNgayDaCo === undefined) return null;
  if (soNgayDaCo >= soNgayCuaKy) return null;

  /*
   * Chỉ in "7/28 ngày" chứ không cả câu: ở cột số của bảng kênh, câu đầy đủ
   * dài gấp bốn lần con số nên nó xuống năm dòng và đẩy cả hàng cao gấp ba.
   * Câu giải thích nằm ở `title`.
   */
  return (
    <span
      className="so-lieu whitespace-nowrap text-phu text-warn-chu"
      title={`Kỳ này cần ${String(soNgayCuaKy)} ngày nhưng chỉ có số liệu của ${String(soNgayDaCo)} ngày, nên không so được với kỳ trước.`}
    >
      {soNgayDaCo}/{soNgayCuaKy} ngày
    </span>
  );
}
